import Papa from "papaparse";
import { Observable } from "rxjs";
import { BaseExcelDocumentBuilder, InvalidStructureError } from "./BaseExcelDocumentBuilder.js";
class CsvDocumentBuilder extends BaseExcelDocumentBuilder {
  parseFile(file, columns) {
    const reader = new FileReader();
    return {
      resultObservable: new Observable((subscriber) => {
        reader.readAsText(file);
        reader.onload = () => {
          try {
            const csvData = reader.result.replace(/\r?\n\s*$/, "");
            let fileLine = 2;
            const result = [];
            const columnsList = Object.values(columns);
            const parseResult = Papa.parse(csvData, {
              header: true,
              skipEmptyLines: false,
              transformHeader: (key) => columnsList.find((c) => c.header === key)?.key ?? key,
              transform: (value) => value.trim(),
              step: (stepResult) => {
                result.push({ ...stepResult.data, rowIndex: fileLine.toString() });
                fileLine++;
              }
            });
            if (parseResult.errors?.length > 0) {
              throw new Error("Can not parse file", {
                cause: parseResult.errors
              });
            }
            this.verifyParsedColumnsStructure(parseResult.meta.fields, columns);
            subscriber.next(result);
            subscriber.complete();
          } catch (e) {
            subscriber.error(e);
          }
        };
        reader.onerror = (error) => subscriber.error(error);
      }),
      onCancel: () => {
        reader.abort();
      }
    };
  }
  getDocument() {
    const result = this.workbook.csv;
    this.reset();
    return result;
  }
  verifyParsedColumnsStructure(headers, columns) {
    Object.keys(columns).forEach((key, index) => {
      const recievedValue = headers[index]?.toString() ?? "";
      if (recievedValue !== key) {
        throw new InvalidStructureError("Incorrect structure", {
          cause: {
            expectedValue: columns[key].header,
            recievedValue
          }
        });
      }
    });
  }
}
export {
  CsvDocumentBuilder
};
//# sourceMappingURL=CsvDocumentBuilder.js.map
